module.exports = __webpack_public_path__ + "img/iaa-12.7ebdb194.jpg";